// extracted by mini-css-extract-plugin
export default {"root":"legend-container_root__+g6be","legend":"legend-container_legend__82U5J","placeHolderShimmer":"legend-container_placeHolderShimmer__u7Skl"};